export default __webpack_public_path__ + "static/media/m-fsk-11.51603018.jpg";